<template>
  <v-container fluid class="page--deposit">
    <v-row class="page-content pt-8">
      <!-- alert -->
      <v-col cols="12" class="text-center">
        <h4 class="text-h5 mb-1 font-weight-semibold">
          Choose a deposit method
        </h4>
        <p class="text--secondary">
          Maximise your deposit value by picking high bonuses!
        </p>
      </v-col>

      <!-- TODO redesign this is gay -->
      <v-col v-if="!disabled.referral && !hasAffiliateBonus" cols="12">
        <v-sheet
          class="rounded-0 py-4 link"
          :class="{'method--disabled': disabled.referral}"
          color="green900 green300--text"
          @click="$modal.open('refcode', {maxWidth: 400})"
        >
          <p v-if="disabled.referral" v-t="'common.disabled'" class="mb-0 text-center text--disabled" />

          <div v-else-if="hasAffiliateBonus" class="d-flex align-center justify-center">
            <fai v-if="hasAffiliateBonus" :icon="['fas', 'check']" class="mr-2" />
            <h5 v-t="'page.deposit.refcode.redeemed'" class="text-body-1 font-weight-semibold lh-1-3" />
          </div>

          <div v-else class="d-flex justify-space-between align-center px-4">
            <div>
              <h5 v-t="'page.deposit.refcode'" class="text-body-1 font-weight-semibold" />
              <h6 v-t="'page.deposit.refcode.desc'" class="text-body-2" />
            </div>

            <span class="text-h5 green500--text extra-bonus font-weight-bold">
              +{{ highestAffBonus * 100 | toLocale }}%
            </span>
          </div>
        </v-sheet>
      </v-col>


      <!-- giftcards -->
      <v-col cols="12" md="6">
        <h4 class="text-h6 font-weight-semibold d-flex align-center mb-1">
          <fai :icon="['fad', 'gift-card']" class="mr-3" />
          Purchase Giftcards
        </h4>
        <p class="text--secondary text-body-2">
          Kinguin offers a large variety of payment methods
        </p>

        <v-card
          class="big-depo-card link mb-2 of-hidden" color="grey800" :ripple="false" tile
          @click="onGiftcardsClick"
        >
          <v-overlay absolute :value="disabled.giftcards" opacity=".8">
            <span v-t="'common.disabled'" class="text-uppercase text-body-2 font-weight-bold primary200--text" />
          </v-overlay>
          <div v-if="bonuses.giftcards" class="bonus-label green600 green100--text">
            +{{ bonuses.giftcards * 100 | toLocale }}%
          </div>
          <div class="grey700 py-6">
            <v-img
              :max-width="220" contain
              class="mx-auto"
              src="/img/providers/kinguin.svg"
            />
          </div>
          <div class="px-4 py-6">
            <v-row>
              <v-col
                v-for="(provider, i) in cashProviders" :key="i"
                cols="6" md="4" lg="3"
              >
                <v-img
                  :aspect-ratio="2"
                  :max-width="provider.iconSize" contain
                  class="mx-auto"
                  :src="provider.icon"
                />
              </v-col>
            </v-row>

            <v-row cols="12" class="d-flex align-center justify-center blue200--text py-1">
              <fai :icon="['fas', 'plus-circle']" class="mr-2 text-body-2" />
              <span class="text-uppercase font-weight-semibold text-caption lh-1">Many more payment methods</span>
            </v-row>
          </div>
        </v-card>

        <div
          class="green800 px-4 py-3 text-center link green200--text"
          @click="$modal.open('giftcard-redeem', { maxWidth: 400 })"
        >
          <fai :icon="['fad', 'gift-card']" class="text-body-1 mr-2 green100--text" />
          <span class="text-uppercase font-weight-bold text-body-2">Redeem giftcard</span>
        </div>
      </v-col>

      <!-- cash -->
      <v-col cols="12" md="6" class="d-flex flex-column">
        <h4 class="text-h6 font-weight-semibold d-flex align-center mb-1">
          <cryptoicon symbol="usd" size="1em" class="mr-2" />
          Buy skins with cash
        </h4>
        <p class="text--secondary text-body-2">
          Skinmarket offers a 40% bonus on cash deposit
        </p>

        <v-card
          class="big-depo-card link full-height of-hidden d-flex flex-column" :ripple="false" color="grey800" tile
          rel="noopener" target="_blank"
          href="https://skinmarket.gg?utm_source=bandit.camp&utm_medium=deposit_page&utm_campaign=paid_placement"
        >
          <div class="grey700 py-9">
            <v-img
              :max-width="275" contain
              class="mx-auto"
              src="/img/providers/skinmarket.png"
            />
          </div>
          <div class="px-4 py-3 flex-grow-1">
            <v-row align="center" class="fill-height">
              <v-col cols="6" md="4">
                <v-img
                  :aspect-ratio="2"
                  :max-width="72" contain
                  class="mx-auto"
                  src="/img/providers/visa.svg"
                />
              </v-col>
              <v-col cols="6" md="4">
                <v-img
                  :aspect-ratio="2"
                  :max-width="72" contain
                  class="mx-auto"
                  src="/img/providers/mastercard.svg"
                />
              </v-col>
              <v-col cols="6" md="4">
                <v-img
                  :aspect-ratio="2"
                  :max-width="100" contain
                  class="mx-auto"
                  src="/img/providers/stripe.png"
                />
              </v-col>
              <v-col cols="12" class="d-flex align-center justify-center">
                <cryptoicon symbol="btc" size="2.5em" class="mx-2" />
                <cryptoicon symbol="eth" size="2.5em" class="mx-2" />
                <cryptoicon symbol="ltc" size="2.5em" class="mx-2" />
              </v-col>
              <v-col
                align-self="end"
                cols="12"
                class="py-1 text-caption text--disabled text-center font-weight-semibold"
              >
                Once bought, you can deposit the skins here below.
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>

      <!-- steam -->
      <v-col cols="12">
        <v-row dense>
          <v-col cols="12" class="py-1">
            <h4 class="text-h6 font-weight-semibold d-flex align-center">
              <fai :icon="['fab', 'steam']" class="mr-2 primary500--text" />
              Steam items
            </h4>
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <DepositMethod
              title="Backpack deposit"
              :disabled="disabled.market"
              @click="onRustClick"
            >
              <template #icon>
                <v-img width="120" class="flex-grow-0" src="/img/providers/rust-backpack.svg" />
              </template>
            </DepositMethod>
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <DepositMethod
              title="Sell backpack items"
              @click="onSellClick"
            >
              <template #icon>
                <v-img width="120" class="flex-grow-0" src="/img/providers/rust-scrap.svg" />
              </template>
            </DepositMethod>
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <DepositMethod
              title="CS:GO items"
              :bonus="bonuses.skinsback"
              :disabled="disabled.skinsback"
              @click="onSkinsbackClick"
            >
              <template #icon>
                <v-img width="112" class="flex-grow-0" src="/img/providers/csgo.png" />
              </template>
            </DepositMethod>
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <DepositMethod
              title="Dota 2 items"
              :bonus="bonuses.skinsback"
              :disabled="disabled.skinsback"
              @click="onSkinsbackClick"
            >
              <template #icon>
                <v-img width="72" class="flex-grow-0" src="@/assets/img/logos/dota.svg" />
              </template>
            </DepositMethod>
          </v-col>
        </v-row>
      </v-col>

      <!-- crypto -->
      <v-col cols="12">
        <v-row dense>
          <v-col cols="12" class="py-1">
            <h4 class="text-h6 font-weight-semibold d-flex align-center">
              <cryptoicon symbol="btc" size="1em" class="mr-n2" />
              <cryptoicon symbol="eth" size="1em" class="mr-n2" />
              <fai :icon="['fas', 'plus-circle']" class="mr-2 text--secondary" />
              Cryptocurrencies
            </h4>
          </v-col>

          <v-col
            v-for="coin in enabledCoins" :key="coin"
            cols="12" sm="6" md="3"
          >
            <DepositMethod
              :title="CRYPTO_NAMES[coin]"
              :bonus="bonuses.crypto[coin]"
              :disabled="disabled.crypto"
              @click="onCryptoClick(coin)"
            >
              <template #icon>
                <cryptoicon :symbol="CRYPTO_CODES[coin]" size="4em" />
              </template>
            </DepositMethod>
          </v-col>

          <v-col cols="12" class="pt-3">
            <h4 class="text-body-2 font-weight-semibold d-flex align-center">
              No crypto?
            </h4>
            <p class="mb-0 text-body-2 text--secondary">
              Buy from these trusted websites (unaffiliated links).
            </p>
          </v-col>

          <v-col
            v-for="(site, i) in cryptoSites" :key="i"
            cols="12" sm="6" md="4" lg="3"
          >
            <a
              class="full-height link grey800 py-3 d-flex align-center justify-center"
              :href="site.url" target="_blank" rel="noopener noreferrer"
            >
              <v-img width="32" class="flex-grow-0 mr-3" :src="site.icon" />
              <span class="blue200--text" v-text="site.name" />
            </a>
          </v-col>
        </v-row>
      </v-col>

      <!-- other ways -->
      <v-col cols="12">
        <v-row dense>
          <v-col cols="12" class="py-1">
            <h4 class="text-h6 font-weight-semibold d-flex align-center">
              Other ways to get scrap
            </h4>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <DepositMethod
              :to="{name:'Offers'}"
              title="Offers &amp; surveys"
              :disabled="disabled.offerwalls"
            >
              <template #icon>
                <v-img width="128" class="flex-grow-0" src="@/assets/img/logos/offers/offertoro.png" />
              </template>
            </DepositMethod>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <DepositMethod
              :to="{name:'Offers'}"
              title="Offers &amp; surveys"
              :disabled="disabled.offerwalls"
            >
              <template #icon>
                <v-img width="128" contain class="flex-grow-0" src="@/assets/img/logos/offers/adscend.png" />
              </template>
            </DepositMethod>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <DepositMethod
              :to="{name:'Offers'}"
              title="Offers &amp; surveys"
              :disabled="disabled.offerwalls"
            >
              <template #icon>
                <v-img width="128" class="flex-grow-0" src="@/assets/img/logos/offers/adgate.png" />
              </template>
            </DepositMethod>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <DepositMethod
              :to="{name:'Offers'}"
              title="Offers &amp; surveys"
              :disabled="disabled.offerwalls"
            >
              <template #icon>
                <v-img width="128" class="flex-grow-0" src="@/assets/img/logos/offers/adgem.png" />
              </template>
            </DepositMethod>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <DepositMethod
              :to="{name:'Offers'}"
              title="Offers &amp; surveys"
              :disabled="disabled.offerwalls"
            >
              <template #icon>
                <v-img width="128" class="flex-grow-0" src="@/assets/img/logos/offers/lootably.png" />
              </template>
            </DepositMethod>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <DepositMethod
              title="Promo codes"
              :disabled="disabled.giftcodes"
              @click="onPromocodesClick"
            >
              <template #icon>
                <fai :icon="['fad', 'gift-card']" class="text-h3 blue400--text" />
              </template>
            </DepositMethod>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <DepositMethod
              href="https://discord.gg/banditcamp"
              target="_blank" rel="noopener noreferrer"
              title="Discord giveaways"
            >
              <template #icon>
                <fai :icon="['fab', 'discord']" class="text-h3" style="color: #5865f2;" />
              </template>
            </DepositMethod>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <DepositMethod
              href="https://twitter.com/banditcamprust"
              target="_blank" rel="noopener noreferrer"
              title="Twitter giveaways"
            >
              <template #icon>
                <fai :icon="['fab', 'twitter']" class="text-h3 blue400--text" />
              </template>
            </DepositMethod>
          </v-col>
          <!-- <v-col cols="12" sm="6" md="3">
            <DepositMethod
              title="Farm junkpiles"
              @click="$modal.open('faucet', { maxWidth: 400 })"
            >
              <template #icon>
                <v-img
                  width="150" aspect-ratio="2" class="flex-grow-0"
                  src="@/assets/img/scrap-pile.png"
                />
              </template>
            </DepositMethod>
          </v-col> -->
          <v-col cols="12" sm="6" md="3">
            <DepositMethod
              title="Daily case"
              @click="$modal.open('daily-case', { maxWidth: 800 })"
            >
              <template #icon>
                <fai :icon="['fad', 'box-full']" class="text-h3 green400--text" />
              </template>
            </DepositMethod>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { CRYPTO_CODES, CRYPTO_NAMES } from '@/utils/constants'
import DepositMethod from './components/DepositMethod'
import { CASH_PROVIDERS, CRYPTO_SITES } from './methods'

export default {
  components: { DepositMethod },
  metaInfo() {
    return {
      title: this.$t('page.deposit.title'),
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/session',
      conga: 'conga/conga',
    }),
    cryptoSites() {
      return CRYPTO_SITES
    },
    cashProviders() {
      return CASH_PROVIDERS
    },
    CRYPTO_CODES() {
      return CRYPTO_CODES
    },
    CRYPTO_NAMES() {
      return CRYPTO_NAMES
    },
    enabledCoins() {
      return this.conga.deposits?.crypto?.enabledCoins ?? []
    },
    disabled() {
      const { conga: { deposits } } = this

      return {
        crypto: deposits.crypto.disabled,
        market: deposits.market.disabled,
        skinsback: deposits.skinsback.disabled,
        cash: deposits.cash.disabled,
        referral: this.conga.affiliates.disabled,
        offerwalls: deposits.offerwalls.disabled,
        giftcards: deposits.giftcards.disabled,
        giftcodes: this.conga.promo.giftcodes.disabled,
      }
    },
    hasAffiliateBonus() {
      return !!this.user.affiliateOf
    },
    affiliateBonuses() {
      return this.conga.affiliates.bonus
    },
    highestAffBonus() {
      return Object.values(this.affiliateBonuses).sort((a, b) => b - a)[0]
    },
    bonuses() {
      const { conga: { deposits }, affiliateBonuses, hasAffiliateBonus } = this

      const bonuses = {
        crypto: { ...deposits.crypto.bonuses },
        market: deposits.market.bonus,
        skinsback: deposits.skinsback.bonus,
        giftcards: deposits.giftcards.bonus,
        cash: deposits.cash.bonus,
      }

      if (hasAffiliateBonus) {
        Object.keys(bonuses.crypto).forEach(i => {
          bonuses.crypto[i] += affiliateBonuses.crypto ?? 0
        })

        bonuses.market += affiliateBonuses.market ?? 0
        bonuses.skinsback += affiliateBonuses.skinsback ?? 0
        bonuses.giftcards += affiliateBonuses.giftcards ?? 0
        bonuses.cash += affiliateBonuses.cash ?? 0
      }

      return bonuses
    },
  },
  methods: {
    ...mapMutations({
      setSidebarOpen: 'setSidebarOpen',
    }),
    async onRustClick() {
      if (this.disabled.market) return
      this.$modal.open('backpack-deposit', { maxWidth: 900, noShadow: true })
    },
    async onSellClick() {
      this.setSidebarOpen(true)
      this.$toast.info('Select items in your backpack to sell them.')
    },
    async onSkinsbackClick() {
      if (this.disabled.skinsback) return

      this.$modal.open('skinsback', { maxWidth: 400 }, { bonus: this.bonuses.skinsback })
    },
    onCryptoClick(coin) {
      if (this.disabled.crypto) return

      this.$modal.open('crypto-deposit', { maxWidth: 500 }, { coin })
    },
    onGiftcardsClick() {
      if (this.disabled.giftcards) return

      this.$modal.open('giftcards', { maxWidth: 500 }, { bonus: this.bonuses.giftcards })
    },
    onCashClick() {
      if (this.disabled.cash) return

      this.$modal.open('paydash', { maxWidth: 400 }, { bonus: this.bonuses.cash })
    },
    onPromocodesClick() {
      if (this.disabled.giftcodes) return

      this.$modal.open('giftcodes', { maxWidth: 400 })
    },
  },
}
</script>


<style lang="scss" scoped>
.page--deposit {
  min-height: calc(100vh - var(--top));
  background: grey(900); // fallback
  background: url('../../assets/img/shop.jpg') no-repeat top center;
  background-size: cover;

  &::before {
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(rgba(grey(800), 0.9) 50%, rgba(grey(800), 0.99) 80%);
    content: ' ';
    // pointer-events: none;
  }
}

.page-content {
  position: relative;
  z-index: 1;
  max-width: 850px;
  margin: 0 auto;
}

.deposit-method {
  height: 100%;
}

.bg-ui-panel--dark {
  background-color: rgba(#524e48, 0.75);
}

.bg-ui-panel--light {
  background-color: rgba(#807b72, 0.75);
}

.big-depo-card {
  .bonus-label {
    position: absolute;
    top: 0;
    right: 0;
    padding: 5px 60px 6px 60px;
    font-size: 16px;
    font-weight: 900;
    line-height: 1;
    transform: rotate(30deg) translate(25%, -40%);
  }
}
</style>
